import { render } from "./ToDoWidgetButton.vue?vue&type=template&id=a42a1b5c&scoped=true&ts=true"
import script from "./ToDoWidgetButton.vue?vue&type=script&lang=ts"
export * from "./ToDoWidgetButton.vue?vue&type=script&lang=ts"

import "./ToDoWidgetButton.vue?vue&type=style&index=0&id=a42a1b5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42a1b5c"]])

export default __exports__